<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">消息推送</h1>
		<h3 class="doc_main_h3">消息推送</h3>
		<p class="doc_main_p">
			message_push接口提供了消息推送的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/message_push">https://skfrm.cn/APIV2/message_push</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-value :propsTableData='frmReturnvalue'></frm-Return-value>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{          
            "error_code":"0",
            "error_msg":"success",
            "ret_info":"Push received"
	}
失败：
	{
		"error_code":"6001",
		"error_msg":"推送服务器内部错误",
		"ret_info":""
	}
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
	import FrmReturnvalueTable from '../../../../components/frmReturnvalueTable';	
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,		
			'frm-Return-value':FrmReturnvalueTable,
			'frm-Error-Code':FrmErrorCodeTable,
		},
		data(){
			return{
				isPathData:['FRM API-v2','消息推送','消息推送'],			
				frmRequestParams:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id"},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token"},
					{"require":"是","name":"project_id","type":"int","msg":"项目id"},
					{"require":"是","name":"udid","type":"string","msg":"终端唯一设备号"},
					{"require":"是","name":"msg","type":"string","msg":"推送指令，例如  [RemoteOpenDoor]"},
				],
				frmReturnvalue:[
					{"Parameter":"error_code","name":"string","msg":"0 成功  1 失败"},
					{"Parameter":"error_msg","name":"string","msg":"成功返回 success  失败返回 fail"},
					{"Parameter":"ret_info","name":"string","msg":"返回信息"},
				],
				frmErrorCode:[
					{"Statuscode":"1003","errormessage":"msg格式错误","msg":"指令格式错误，例 [RemoteOpenDoor]"},
					{"Statuscode":"1013","errormessage":"服务器内部错误","msg":"服务器内部错误"},
					{"Statuscode":"1014","errormessage":"服务器连接失败","msg":"服务器连接失败"},
					{"Statuscode":"3003","errormessage":"udid无效","msg":"唯一设备号不存在"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
					{"Statuscode":"9003","errormessage":"响应超时","msg":"响应超时"},
					{"Statuscode":"10001","errormessage":"服务器繁忙","msg":"服务器繁忙"},
					{"Statuscode":"10002","errormessage":"推送终端不在线","msg":"推送终端不在线"},
					{"Statuscode":"10003","errormessage":"推送消息网络通信失败, 远程设备可能处于离线","msg":"推送消息网络通信失败, 远程设备可能处于离线"},
					{"Statuscode":"10004","errormessage":"无效的udid","msg":"无效的udid"},
					{"Statuscode":"10005","errormessage":"终端无应答，推送可能无法抵达","msg":"终端无应答，推送可能无法抵达"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Messagepush/messagePush.vue